import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

interface Props {
  criarRevisoes: boolean;
  setCriarRevisoes: (v: boolean) => void;
}

export function FieldsRevisao({ criarRevisoes, setCriarRevisoes }: Props) {
  return (
    <div className="flex items-center justify-between rounded-lg border border-border p-4 bg-muted/30">
      <div className="space-y-0.5">
        <Label className="text-base font-medium">Agendar revisões</Label>
        <p className="text-sm text-muted-foreground">
          {criarRevisoes
            ? 'Revisões serão criadas automaticamente'
            : 'Apenas o histórico será salvo'}
        </p>
      </div>
      <Switch checked={criarRevisoes} onCheckedChange={setCriarRevisoes} />
    </div>
  );
}
